<template>
  <div class="letter_wrap">
    <div class="red_top_bg">
      <div class="big_tit">
        {{ $t('feng.ads') }}
      </div>
    </div>
    <div
      v-if="acc&&vip"
      class="content"
    >
      <div
        v-if="vips"
        style="padding-bottom: 1vh;margin-top: 10px;"
      >
        <template v-for="(it,i) in vips">
          <div
            class="vip"
            :class="'cssvip'+it.no"
          >
            <div class="leftInfo">
              <div class="vip-title vip1">
                <span><font
                  style="vertical-align: inherit;"
                ><font style="vertical-align: inherit;">
                  {{ it.name }}
                </font></font></span>
              </div>
              <div class="jifen">
                <font style="vertical-align: inherit;">
                  <font
                    style="vertical-align: inherit;"
                  >
                    {{ it.value }} {{ $t('sky.jifen') }}
                  </font>
                </font>
              </div>
            </div>
            <div class="iconBox">
              <!-- <img :src="it.imgh" > -->
            </div>
          </div>
        </template>
      </div>
    </div>
		
    <div class="tierBox">
      <div>
        <img
          class="adslogo"
          src="../images/ban2/logo.svg"
        >
      </div>
		   
      <div style="font-size: 20px;line-height: 30px;word-break: auto-phrase;padding: 15px 0px;font-weight: bold;border-top: 2px solid #ccc;">
        Ingin lebih hemat saat berpergian?Perkenalkan
      </div>
      <div>
        <img
          class="adslogo"
          src="../images/ban2/vhead.svg"
        >
      </div>
      <div style="word-break: auto-phrase;">
        Maksimalkan perjalanan Anda dengan Expedia Rewards.Bergabunglah hari ini untuk mulai mengumpulkan poin, menikmati Harga Member, dan mulai mendapatkan manfaat keangotaan.
      </div>
      <div>
        <img
          style="width: 100%;margin: 15px 0;"
          src="../images/ban2/v1.png"
        >
      </div>
      <div style="word-break: auto-phrase;">
        Member Expedia Rewards bisa mendapatkan akses langsung ke diskon 10% atau lebih untuk hotel tertentu.
      </div>
      <div>
        <img
          style="width: 100%;margin: 15px 0;"
          src="../images/ban2/v2.png"
        >
      </div>
      <div style="word-break: auto-phrase;">
        Dengan setiap penerbangan, hotel, dan aktivitas yang memenuhi syarat, Anda juga mengumpulkan Elemen Perjalanan. Dan hal ini membuat Anda semakin dekat ke level Expedia Rewards berikutnya.
      </div>
      <div>
        <img
          style="width: 100%;margin: 15px 0;"
          src="../images/ban2/v3.gif"
        >
      </div>
      <div style="color: #727d91;word-break: auto-phrase;">
        © 2025 Expedia, Inc., perusahaan Expedia Group. Hak cipta dilindungi oleh undang-undang. Expedia dan Logo Expedia adalah merek dagang atau merek dagang terdaftar dari Expedia, Inc. 
      </div>
      <div style="margin-bottom: 100px;margin-top: 20px;">
        <img
          style="width: 200px;"
          src="../images/ban2/v5.svg"
        >
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
	
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	export default {
		name: "Ads",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				empty: false,
				baners:[
					'background-image: linear-gradient(to left, rgb(207, 224, 238), rgb(164, 184, 214));',
					'background-image: linear-gradient(to left, rgb(249, 195, 196), rgb(246, 142, 143));',
					'background-image: linear-gradient(to left, rgb(246, 226, 163), rgb(249, 168, 87));',
					'background-image: linear-gradient(to left, rgb(152, 216, 253), rgb(1, 148, 243));',
					'background-image: linear-gradient(to left, rgb(118, 173, 255), rgb(65, 77, 224));',
					'background-image: linear-gradient(to left, rgb(180, 137, 255), rgb(128, 14, 255));',
					'background-image: linear-gradient(to left, rgb(253, 154, 230), rgb(194, 35, 242));',
					'background-image: linear-gradient(to left, rgb(61, 235, 235), rgb(0, 188, 225));',
					'background-image: linear-gradient(to left, rgb(129, 235, 186), rgb(0, 213, 178));',
					'background-image: linear-gradient(to left, rgb(101, 108, 149), rgb(46, 53, 64));'
				],
				cur:-1,
				acc: null,
				vip: null,
				vips: null
			};
		},
		created() {
			this.$parent.footer('ads',true);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/info').then((r) => {
					this.acc = r.data;
					this.vip = r.data.vip;
					this.vips = r.data.vips;
				});
			},
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		position: relative;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
	}
	.content .top-logo {
		width: 100%;
		margin-top: 1.5rem;
		margin-left: .4rem
	}
	
	.content .top-logo img {
		width: 1.4rem;
		height: 1.4rem
	}
	
	.content .userHead {
		width: 100%;
		background-image: url(../images/shop2/myImg.png);
		background-repeat: no-repeat;
		background-size: 100% auto;
		height: 6.4rem;
		// background-color: #ff5d7a;
	}
	
	.content .userHead .head_info {
		height: 4rem;
		width: 100%
	}
	
	.content .nav_user {
		width: 100%;
		padding: .4rem 0 0 0
	}
	
	.content .nav_user .info {
		margin-left: 3%;
		width: 94%;
		margin-top: .8rem;
		margin-bottom: .2rem;
		color: #fff;
		height: 2.4rem;
		text-align: center
	}
	
	.content .nav_user .info .img img {
		padding: .05rem;
		background: linear-gradient(to right bottom,#0194f3,#ffe4f4,#76dfff,#0194f3);
		border-radius: 1rem;
		width: 1.6rem
	}
	
	.content .nav_user .info .vip {
		width: 100%;
		margin-left: 25px;
		margin-top: -25px;
	}
	
	.content .nav_user .info .vip img {
		padding: .05rem;
		border-radius: 1rem;
		width: 30px;
	}
	
	.content .nav_user .info .account {
		margin-left: .2rem
	}
	
	.content .nav_user .info .account .name {
		font-size: .5rem;
		font-weight: 600;
		font-family: "Helvetica, Arial, sans-serif";
		color: #fff
	}
	
	.content .nav_user .info .account .level {
		margin-top: .1rem;
		border-radius: .2rem;
		background: linear-gradient(90deg,#f4d588,#9f7547);
		padding: .1rem .2rem;
		display: inline-block
	}
	
	.content .nav_user .balance {
		display: flex;
		margin-left: 3%;
		width: 94%;
		border-radius: .2rem
	}
	
	.content .nav_user .balance .u-count-num {
		font-size: .34rem;
		color: #fff;
		font-weight: 600
	}
	
	.content .nav_user .balance .nav-name {
		color: #fff;
		text-align: center;
		line-height: 1.2em;
		margin-top: .1rem;
		font-weight: 600
	}
	
	.content .nav_user .balance .nav-item {
		padding: 0 .05rem;
		width: 50%;
		margin: .2rem 0;
		box-sizing: border-box;
		padding: 0 0 .2rem 0
	}
	
	.content .btn {
		width: 94%;
		margin: .1rem 3% .2rem 3%;
		height: 1rem;
		font-size: .3rem;
		font-weight: 600;
		border-radius: .2rem;
		border: 0;
		background-color: #1b1b1b;
		color: #fff
	}
	
	.content .center-nav {
		background-color: #fff;
		margin-bottom: .3rem;
		display: flex;
		flex-wrap: wrap
	}
	
	.content .center-nav .center-item {
		display: flex;
		align-items: center;
		width: 50%;
		box-sizing: border-box;
		padding: .3rem 0 .3rem .6rem;
		border-bottom: 1px solid #dcdcdc;
		border-right: 1px solid #dcdcdc
	}
	
	.content .center-nav .center-item:nth-child(3),.content .center-nav .center-item:nth-child(4) {
		border-bottom: 0
	}
	
	.content .center-nav .center-item .icon {
		width: .4rem;
		height: .4rem;
		margin-right: .3rem;
		background-repeat: no-repeat;
		background-size: cover
	}
	
	.content .center-nav .center-item .right .name {
		font-size: .28rem
	}
	
	.content .center-nav .center-item .right .tip {
		font-size: .24rem;
		color: #999
	}
	
	.content .bottom-nav-flex {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		text-align: center;
		margin-top: -1.2rem;
		border-radius: .2rem;
		width: 100%;
		margin-bottom: .1rem
	}
	
	.content .bottom-nav-flex .site {
		width: 94%;
		margin: .1rem 3% .2rem 3%;
		background-color: #616162;
		background-image: linear-gradient(180deg,#767678,#c6c7ca);
		text-align: center;
		font-size: .32rem;
		line-height: .8rem;
		color: #fff;
		border-radius: .2rem
	}
	
	.content .bottom-nav-flex .active-item {
		background-image: url(../images/shop2/banner.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		height: 2.4rem!important;
		width: 94%!important;
		margin-left: 3%!important;
		margin-bottom: .2rem!important;
		padding: 0!important
	}
	
	.content .bottom-nav-flex .bottom-item {
		color: #000;
		width: 90%;
		height: 1.22rem;
		padding: 0 5%;
		font-size: .28rem
	}
	
	.content .bottom-nav-flex .bottom-item:last-child {
		border-bottom: 0
	}
	
	.content .bottom-nav-flex .bottom-item .img {
		width: .4rem;
		margin-top: .45rem;
		float: left
	}
	
	.content .bottom-nav-flex .bottom-item .icon {
		width: .5rem;
		height: .5rem;
		text-align: center;
		margin-right: .2rem;
		background-repeat: no-repeat;
		background-size: contain
	}
	
	.content .bottom-nav-flex .bottom-item .rightImg {
		float: right;
		margin-right: .3rem;
		margin-top: .5rem;
		width: .3rem;
		height: .3rem
	}
	
	.content .bottom-nav-flex .bottom-item .right {
		align-items: center;
		justify-content: space-between;
		margin-left: .4rem;
		line-height: 1.32rem;
		height: 1.32rem;
		float: left
	}
	
	.content .bottom-nav-flex .bottom-item .right .arrow {
		font-size: .3rem
	}
	
	.content .bottom-nav {
		background-color: #fff;
		margin-bottom: .3rem
	}
	
	.content .bottom-nav .bottom-item {
		display: flex;
		padding: .3rem;
		border-bottom: 1px solid #dcdcdc
	}
	
	.content .bottom-nav .bottom-item:last-child {
		border-bottom: 0
	}
	
	.content .bottom-nav .bottom-item .icon {
		width: .4rem;
		height: .4rem;
		margin-right: .2rem;
		background-repeat: no-repeat;
		background-size: contain
	}
	
	.content .bottom-nav .bottom-item .right {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 90%
	}
.itemInfo{
	width: 94%;
	margin-left: 3%;
	position: relative;
}

.itemInfo img{
	width: 100%;
	
}

.itemInfo .vipInfo{
	width: 100%;
	height: 3.3rem;
	display: grid;
	position: absolute;
	top: 0px;
}

.itemInfo .vipInfo .name{
	width: 100%;
	color: #fff;
	font-size: 20px;
	font-weight: 600;
	margin-left: 30px;
	margin-top: 20px;
	height: 60px;
}

.itemInfo .vipInfo .nav_opr{
	width: 90%;
	margin-left: 5%;
	margin-top: 35px;
	height: 60px;
	text-align: left;
	font-size: 14px;
}

.itemInfo .vipInfo .nav_opr .w{
	margin-right: 10px;
	line-height: 20px;
}

.itemInfo .vipInfo .nav_opr .r,.itemInfo .vipInfo .nav_opr .w{
	width: 33%;
	margin-top: .1rem;
	float: left;
	padding: .1rem;
	color: #fff;
	line-height: 20px;
}
.item{
    width: 94%;
    height: 1.2rem;
    margin: .2rem 3%;
    border-radius: .2rem
}

.item .left{
    float: left;
    margin-left: .4rem
}

.item .left .name{
    color: #fff;
    line-height: 1.2rem
}

.item .right{
    float: right
}

.item .right img{
    width: .4rem;
    margin-top: .4rem;
    margin-right: .4rem
}
.tierBox{
    display: flex;
    flex-direction: column;
    align-items: center;
	margin-bottom: 10vh;
	.tierTitle{
		color: #303133;
		font-size: 14px;
	}
}
.vip{
    margin: 0 11px 15px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;
    background: #fff;
    border-radius: 11px;
    padding: 0 15px;
	.vip-title{
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: bold;
		line-height: 30px;
		margin-bottom: 20px;
	}
	.jifen {
	    font-size: 14px;
	    font-family: PingFangSC-Regular,PingFang SC;
	    font-weight: 400;
	}
	.iconBox{
	    display: flex;
	    align-items: center;
		img{
			width: 126px;
			margin-right: -34px;
		}
	}
}

.cssvip0{
	background-color: yellow;
	color: #000;
}
.cssvip1{
	background-color: #ff5d7a;
	color: #FFF;
}
.cssvip2{
	background-color: #c0c0c0;
	color: #000;
}
.cssvip3{
	background-color: #FFC107;
	color: #000;
}
.adslogo{
	height: 25px;
	margin: 5px 20px;
}
.tierBox{
	line-height: 25px;
	margin: 0 11px 11px;
	text-align: center;
	color: #000;
	word-break: auto-phrase;
}
</style>
 